import * as React from "react";

function SvgAdjust(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 23 21.2"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <circle cx={11.5} cy={10.6} r={10.5} />
      <path
        d="M19.2 14.8c.5.9-.5 2.2-1.6 1.5 0 0-4.5-2.9-7.7-4.2l-2 3.7c-.1.4-.9.9-1.6.5C.7 13.1 1.7 6.9 8.6 9l2.8-5.4c.6-.9 1.8-.7 2.1 0l5.7 11.2zM7.6 11.3C3.1 10 5.5 13 6.4 13.6l1.2-2.3zm7.6.8l-2.8-5.3-1.6 3.2c1.1.3 3.4 1.6 4.4 2.1z"
        fill="#fff"
      />
    </svg>
  );
}

export default React.forwardRef(SvgAdjust);
